//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useContext } from 'react';
import { ChatContext } from '@/contexts/ChatContext';

/**
 * Access the chat transcript.  Subscribes only to the chat context, so
 * chat changes never re-render main-context consumers and vice versa.
 */
export function useChat() {
  const context = useContext(ChatContext);
  if (!context)
    throw new Error('useChat must be used within a ChatProvider');

  return context;
}
